import React from 'react';
import { ArrowLeft, Save, X } from 'lucide-react';

import { Badge } from 'shadcn/components/ui/Badge';
import { Button } from 'shadcn/components/ui/Button';

/**
 * @param {Object} props
 * @param {boolean} [props.isDisabled=false]
 * @param {() => void} props.onBack
 * @param {() => void} props.onCancel
 * @param {() => void} props.onSave
 * @param {string | React.ReactNode | null} [props.statusLabel=null]
 * @param {string | React.ReactNode} props.title
 */
export function CrossDockPurchaseOrderCreatePageHeader({
    isDisabled = false,
    onBack,
    onCancel,
    onSave,
    statusLabel = null,
    title,
}) {
    return (
        <div className="flex w-full flex-wrap items-start gap-3 lg:items-center">
            <Button type="button" variant="ghost" size="sm" onClick={onBack} className="-ml-2" disabled={isDisabled}>
                <ArrowLeft className="mr-2 h-4 w-4" aria-hidden="true" />
                Back to list
            </Button>

            <div className="flex flex-1 flex-wrap items-center gap-3">
                <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
                {statusLabel ? <Badge variant="outline">{statusLabel}</Badge> : null}
            </div>

            <div className="ml-auto flex shrink-0 items-center gap-2">
                <Button type="button" variant="outline" size="sm" onClick={onCancel} disabled={isDisabled}>
                    <X className="mr-2 h-4 w-4" aria-hidden="true" />
                    Cancel
                </Button>
                <Button type="button" variant="default" size="sm" onClick={onSave} disabled={isDisabled}>
                    <Save className="mr-2 h-4 w-4" aria-hidden="true" />
                    Save
                </Button>
            </div>
        </div>
    );
}

CrossDockPurchaseOrderCreatePageHeader.displayName = 'CrossDockPurchaseOrderCreatePageHeader';
